import { Tokens } from '@/assets/tokens'
import styled from 'styled-components'

export const ExclusionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
  padding: 20px 24px;
  background: linear-gradient(135deg, #fff9e6 0%, #fff4d6 100%);
  border: 1px solid #ffd966;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(255, 193, 7, 0.1);
`

export const ExclusionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
`

export const WarningIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff9800;
`

export const ExclusionDescription = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${Tokens.ColorTextSecondary};
  line-height: 1.5;
`

export const CheckboxContainer = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
`

export const CheckboxWrapper = styled.label<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  padding: 8px 12px;
  border-radius: 8px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ $disabled }) => ($disabled ? 'transparent' : 'rgba(1, 195, 141, 0.05)')};
  }
`

export const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #01c38d;

  &:disabled {
    cursor: not-allowed;
  }
`

export const CheckboxLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${Tokens.ColorTextPrimary};
  user-select: none;
`

export const ValidationMessage = styled.div<{ $type: 'error' | 'warning' }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background-color: ${({ $type }) => ($type === 'error' ? '#ffebee' : '#fff9e6')};
  border: 1px solid ${({ $type }) => ($type === 'error' ? '#ef5350' : '#ffd966')};
  border-radius: 8px;
  font-size: 13px;
  color: ${({ $type }) => ($type === 'error' ? '#c62828' : '#f57c00')};
  font-weight: 500;
`
